<template>
  <div>
    <PanelV2
      type="w9"
      mode="simple"
      showGoBack
    >
      <template v-slot:content-solt>
      <img class="icon-tip" src="@/assets/pc/Icon - SMS OTP@2x.png" />
      <span class="title">We need to make sure it's you</span>
      <span class="sub-title">Enter the OTP (One-Time PIN) we sent to your registered mobile number (ending in {{suffixPhone}}). Do not share your OTP.</span>
      <Code ref="codeRef" @otpCode="complete" @clearError="clearError" :error="error" />
      <div class="err-tips" v-if="error">{{error}}</div>
      <div class="send-tips" v-if="isResend && !error">
          <div>New OTP sent.</div>
          <div>You have ({{tryTimes}} of tries) attempt{{tryTimes > 1 ? 's' : ''}} left to request a new OTP.</div>
      </div>
      <div class="tip-wrapper">
          <img src="@/assets/pc/Icon - Information@2x.png" />
          <span>OTP is only valid for 5 minutes.</span>
      </div>
      <!-- 要求出现报错信息是与上方的margin变小变成24px -->
      <div :class="[{'otp-send-bottom' : !error },'otp-send']">
          <span class="link" :class="{'unlink':!countshow}" @click="sendOtp">Resend OTP</span>
          <span class="link-count" v-if="!countshow">({{count}}s)</span>
      </div>
       <el-button type="primary"  @click="next()" >Submit</el-button>
      </template>
    </PanelV2>
    <Dialog
        :title="tipsTitle"
        :visible.sync="dialogVisible"
        width="480px"
        top="31vh"
        :show-close="false"
        center
    >
      <span>{{tipsContent}}</span>
      <template v-slot:footer>
          <el-button type="primary" @click="onOk">OK</el-button>
      </template>
    </Dialog>
  </div>
</template>

<script>
  import Code from '../components/NewCode'
  import {Dialog} from 'element-ui'
  import API from "@/api"
  import {ProcessStatus} from "@/common-data/common.js"
  import {getPageNo} from "@/bdo.process.map.js"
  export default {
    name: 'LoginOtp',
    pRouter: 'App',
    components: {
      Code,
      Dialog
    },
    data() {
      return {
        token: this.getCookieItem("token"),
        userName: this.getCookieItem("userName"),
        suffixPhone: this.getCookieItem("suffixPhone"),
        otpCodeMem: '',
        error: '', // 错误信息
        countshow: true,
        count: '',
        timer: null,
        isResend: false, // 是否再次发送
        dialogVisible: false, // 错误弹窗
        tipsTitle: 'OTP limit reached',
        tipsContent: 'Try again after 30 minutes.',
        tryTimes: 0, // 剩余发送次数
      }
    },
    watch: {
    },
    methods: {
      complete(val) {
        this.otpCodeMem = val
      },
      next() {
        const authCode = this.otpCodeMem
        // 未输入或者未输入完整OTP
        if (authCode.length !== 6) {
          this.error = 'Enter OTP'
          return
        }
        // 不合法OTP后
        if (!/^[0-9]*$/.test(Number(authCode))) {
          this.error = 'Invalid OTP. Double-check your OTP and try again.'
          return
        }
        API.verifyOtp({token: this.token, userName: this.userName, authCode}).then(res => {
          if (res.success) {
            sessionStorage.setItem('authCode', authCode)
            const { processNo = '', applyStatus = '', lastPageNo= '' } = res.obj
            if (!processNo) {
              this.toRoute({name: 'WhetherBDOMerchant'})
              return
            }
            if (applyStatus != '0' && ![5,6].includes(Number(applyStatus))) {
              this.$router.push({name: 'CheckStatus', query: { status: String(applyStatus) }})
            } else if ([5,6].includes(Number(applyStatus))) {
              const name = ProcessStatus[String(processNo)].last
              this.$router.push({name})
            } else {
              let name = ''
              if (lastPageNo) {
                name = getPageNo(String(processNo), String(lastPageNo))
              } else {
                name = ProcessStatus[processNo].first
              }
              this.$router.push({name: 'CheckStatus', query: { status: String(applyStatus), name, processNo }})
            }
          }else{
            switch (res.errorCode) {
              case 'ekyc2.otp.invalid':
                this.error = 'Invalid OTP. Double-check your OTP and try again.'
                break;
              case 'ekyc2.otp.expire':
                this.error = 'Your OTP expired. Request a new OTP by selecting Resend OTP.'
                break;
              case 'ekyc2.otp.multi.invalid':
                this.error = `Invalid OTP, try again. You have (${res.msg} of tries left) attempt${res.msg > 1 ? 's' : ''} before we temporarily lock your account.`
                break;
              case 'sms.otp.error.exceeded.limit':
                this.error = ''
                this.dialogVisible = true;
                this.tipsTitle = 'OTP limit reached.'
                this.tipsContent = `Try again after ${res.msg} minute${res.msg > 1 ? 's':''}.`
                break;
              case 'ekyc2.otp.account.disable.minute':
                this.error = ''
                this.dialogVisible = true;
                this.tipsTitle = 'The account is locked.'
                this.tipsContent = `Try again after ${res.msg} minute${res.msg > 1 ? 's':''}.`
                break;
              case 'ekyc2.otp.account.disable.second':
                this.error = ''
                this.dialogVisible = true;
                this.tipsTitle = 'The account is locked.'
                this.tipsContent = `Try again after less than 1 minute.`
                break;
            
              default:
                this.error = ''
                this.dialogVisible = true;
                this.tipsTitle = `Sorry we're unable to do that right now.`
                this.tipsContent = `Try again later.`
                break;
            }
            // 清空输入框
            this.$refs.codeRef.clearIpt()
          }
        }).catch(err=>{
          this.$refs.codeRef.clearIpt()
          this.error = ''
          this.dialogVisible = true;
          this.tipsTitle = err||`Sorry we're unable to do that right now.`
          this.tipsContent = `Try again later.`
        })
      },
      sendOtp(isResend = true) {
        if(!this.countshow){
            return false;
        }
        // 清空输入框
        this.$refs.codeRef.clearIpt()
        API.sendOtp({token: this.token, userName: this.userName}).then(res => {
          if (res.success) {
              this.tryTimes = res.obj
              this.getCode();
              this.isResend = isResend;
              this.error = ''
          }else{
            switch (res.errorCode) {
              case 'sms.otp.sending.exceeded.limit':
                this.dialogVisible = true
                this.tipsTitle = 'Resend OTP limit reached.'
                this.tipsContent = `Try again after ${res.msg} minute${res.msg > 1 ? 's':''}.`
                break;
              case 'ekyc2.otp.account.disable.minute':
                  this.dialogVisible = true;
                  this.tipsTitle = 'The account is locked.'
                  this.tipsContent = `Try again after ${res.msg} minute${res.msg > 1 ? 's':''}.`
                  break;
              case 'ekyc2.otp.account.disable.second':
                  this.dialogVisible = true;
                  this.tipsTitle = 'The account is locked.'
                  this.tipsContent = `Try again after less than 1 minute.`
                  break;
            
              default:
                this.dialogVisible = true
                this.tipsTitle = `Sorry we're unable to do that right now.`
                this.tipsContent = `Try again later.`
                break;
            }
          }
        }).catch(err=>{
          this.error = ''
          this.dialogVisible = true;
          this.tipsTitle = err||`Sorry we're unable to do that right now.`
          this.tipsContent = `Try again later.`
        })
      },
      clearError() {
        this.error = ''
      },
      getCode(){
        const TIME_COUNT = 60;
        if (!this.timer) {
            this.count = TIME_COUNT;
            this.countshow = false;
            this.timer = setInterval(() => {
                if (this.count > 1 && this.count <= TIME_COUNT) {
                    this.count--;
                    if(this.count < 10){
                        this.count = '0'+this.count
                    }
                } else {
                    this.countshow = true;
                    clearInterval(this.timer);
                    this.timer = null;
                }
            }, 1000)
        }
      },
      onOk() {
          this.dialogVisible = false
          this.$router.push({name: 'CheckMidProcess'})
      }
    },
    mounted() {
        this.sendOtp(false);
    },
    destroyed() {
        if(this.timer){
            clearInterval(this.timer);
        }
    },
  }
</script>


<style lang="scss" scoped>
  .el-button{
     // 按钮primary 样式
  &.el-button--primary {
    border: 0;
    &.is-disabled {
      border: 0;
    }
  }
  }
  
  .panel-v2 {



    .icon-tip {
      width: 60px !important;
    }

    .title {
      margin: 24px 0 0;
      width: 100%;
      text-align: center;
      font: normal normal normal 20px/24px Nunito-bold;
      letter-spacing: 0px;
      color: #2E2E2E;
    }

    .sub-title {
      margin: 24px 0 0;
      width: 83%;
      text-align: center;
      font: normal normal normal 16px/24px Nunito;
      letter-spacing: 0px;
      color: #2E2E2E;
    }
    .otp-send-bottom {
      margin-bottom: 24px;
    }

    .otp-send{
        // margin: 26px 0 0;
        margin-top: 26px;
        text-align: center;
        color: #0072D8;
        font: normal normal bold 16px/24px Nunito-bold;
        .link {
            letter-spacing: 0px;
            cursor: pointer;
            padding: 0 5px;
        }
        .unlink{
            // opacity: 0.6;
            cursor: no-drop;
            color: #919191;
            font: normal normal normal 16px/24px Nunito;
        }
        .link-count{
            // opacity: 0.8;
            font: normal normal normal 16px/24px Nunito;
            color: #919191;
        }
    }

    .otp-wrapper {
      margin: 32px 0 0;
      display: flex;
      width: 100%;
      height: 60px;
      justify-content: space-between;
      align-items: center;

      input {
        width: 42px;
        height: 100%;
        border: 1px solid #99C1E7;
        border-radius: 8px;
        font-size: 45px;
        text-align: center;
        color: #919191;
      }

      img {
        width: 24px;
        height: 24px;
      }
    }

    .tip-wrapper {
      margin: 19px 0 0 0;
      display: flex;
      width: 252px !important;
      align-items: center;
      
      img {
        width: 24px;
        height: 24px;
        margin-right: 6px;
      }

      span {
        color: #919191;
        font: normal normal normal 14px/24px Nunito;
      }

      var {
        font: normal normal normal 14px/24px Nunito-bold;
        letter-spacing: 0px;
        color: #919191;
      }
    }

    .el-button {
      margin: 24px 0 16px 0;
      width: 100%;
      height: 48px;
      border-radius: 8px;
      background-color: #0072d8;
    }
    .err-tips{
        margin-top: 16px;
        text-align: center;
        color: #FF3700;
        font: normal normal normal 16px/24px Nunito;
    }
    .send-tips{
        margin-top: 16px;
        text-align: center;
        font: normal normal normal 16px/24px Nunito;
        color: #2E2E2E;
    }
  }
  ::v-deep .el-dialog{
      border-radius: 16px;
       .el-dialog__header{
            padding-top: 48px;
            padding-bottom: 4px;
            .el-dialog__title{
                text-align: center;
                font: normal normal bold 20px/26px Nunito;
                letter-spacing: 0px;
                color: #2E2E2E;
            }
        }
        .el-dialog__body{
            text-align: center;
            font: normal normal normal 14px/22px Nunito;
            letter-spacing: 0px;
            color: #2E2E2E;
            padding-top: 16px;
            padding-bottom: 32px;
        }
        .el-dialog__footer{
            padding-top: 0;
            padding-bottom: 48px;
            .el-button{
                width: 320px;
                height: 48px;
                border-radius: 8px;
                text-align: center;
                font: normal normal bold 16px/24px Nunito;
                letter-spacing: 0px;
                color: #FFFFFF;
            }
        }
  }

</style>
